import Parse from "parse";
import React from "react";

import { Card, Flex, Tooltip } from "antd";

import { useTranslation } from "@opendash/core";
import { Icon } from "@opendash/icons";

import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { Dragger } from "../features/KanbanView";
import { ParseFieldImage } from "./ParseFieldImage";
import { ParseFields } from "./ParseFields";
import { getObjectActions } from "./helper";

interface Props {
  object?: Parse.Object;
  listeners?: SyntheticListenerMap;
  isDragging?: boolean;
  imageField?: string;
  titleFields?: string[];
  descriptionFields?: string[];
  onChange?: () => void;
}

export const ParseObjectCard = React.memo<Props>(function ParseObjectCard({
  object,
  imageField,
  titleFields,
  descriptionFields,
  listeners,
  isDragging,
  onChange,
}) {
  const t = useTranslation();

  if (!object) {
    return null;
  }

  return (
    <Card
      title={
        <Flex justify="start" align="center" gap="small">
          {listeners !== undefined ? (
            <Dragger
              {...listeners}
              icon="fa:grip-vertical"
              size={16}
              isdragging={isDragging ? "true" : "false"}
            />
          ) : null}
          <ParseFields object={object} fields={titleFields} isInline />
        </Flex>
      }
      cover={<ParseFieldImage object={object} field={imageField} />}
      actions={getObjectActions(object, onChange).map((a) => (
        <Tooltip key={a.key} title={t(a.title)}>
          <Icon icon={a.icon} onClick={a.onClick} />
        </Tooltip>
      ))}
      children={
        <Card.Meta
          description={
            <ParseFields
              object={object}
              fields={descriptionFields}
              isInline
              gap={8}
            />
          }
        />
      }
    />
  );
});
